/** @jsxImportSource theme-ui @jsxRuntime classic */

import { Flex } from '@tishman/components';
import React from 'react';

const TAG_SIZE = 40;
const TAG_SIZE_MOBILE = 24;

export const Tag = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#ffd25b',
        borderRadius: [
          `${TAG_SIZE_MOBILE / 2}px`,
          null,
          null,
          `${TAG_SIZE / 2}px`,
        ],
        fontWeight: 500,
        fontSize: [1, 2],
        height: [`${TAG_SIZE_MOBILE}px`, null, null, `${TAG_SIZE}px`],
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.15)',
        px: ['16px', '24px'],
      }}
    >
      {children}
    </Flex>
  );
};
